import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { ExportListComponent } from './export-list/export-list.component';

@NgModule({
  declarations: [ExportListComponent],
  imports: [SharedModule],
})
export class ExportsModule {}
